import React from "react";
import { Alert } from "react-bootstrap";

/**
 *
 * @param {String} props.type one of 'success', 'info', 'warning', 'error'
 * @param {String} props.keyv any value
 * @param {String} props.message
 */
export default function InfoBox(props) {
  return (
    <Alert key={props.keyv} variant={props.type}>
      {props.message}
    </Alert>
  );
}
